import React from 'react';
// @ts-ignore
import { NavLink } from 'react-router-dom';
class MenuItem extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement(NavLink, { className: "item-navigator col-sm text-center", to: this.props.urlLink }, this.props.nameLink));
    }
}
export default MenuItem;
